const done = (state = false, action) => {
  switch (action.type) {
    case "SET_DONE":
      return action.done;
    default:
      return state;
  }
};

export default done;
